// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-2uvAw","links":"links-x4hFt","links_item":"links_item-1-H3B","addToAppleWallet":"addToAppleWallet-1w0JZ"};